export const useCurrency = () => {
  const { isLoggedIn } = useAuth()

  const { isLoggedInMerchantGroup } = useMerchantGroupAuth()

  const formatToCurrencyString = (
    price: number,
    currencyCode: string,
    {
      compact = false,
      stripTrailingZeros = false,
    }: {
      compact?: boolean
      stripTrailingZeros?: boolean
    } = {}
  ): string => {
    const localeBcp47 = "en-GB"
    const maximumFractionDigits =
      stripTrailingZeros && Number.isInteger(price / 100)
        ? 0
        : 2
    return new Intl.NumberFormat(localeBcp47, {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits,
      minimumFractionDigits: maximumFractionDigits,
      ...(compact && {
        notation: "compact",
      }),
    }).format(price / 100)
  }

  const formatToMerchantCurrencyString = (
    price: number,
    {
      compact = false,
      stripTrailingZeros = false,
    }: {
      compact?: boolean
      stripTrailingZeros?: boolean
    } = {}
  ): string => {
    if (!isLoggedIn.value) {
      throw new Error(
        "formatToMerchantCurrencyString may only be called when logged in as a merchant"
      )
    }

    const { currency } = useTenant()

    return formatToCurrencyString(price, currency.value, {
      compact,
      stripTrailingZeros,
    })
  }

  const formatToMerchantGroupCurrencyString = (
    price: number,
    {
      compact = false,
      stripTrailingZeros = false,
    }: {
      compact?: boolean
      stripTrailingZeros?: boolean
    } = {}
  ): string => {
    if (!isLoggedInMerchantGroup.value) {
      throw new Error(
        "formatToMerchantGroupCurrencyString may only be called when logged in as a merchant group"
      )
    }

    const merchantGroup = useMerchantGroup()

    return formatToCurrencyString(
      price,
      merchantGroup.value?.currency ?? "GBP",
      {
        compact,
        stripTrailingZeros,
      }
    )
  }

  const getCurrencySymbol = (currencyCode: string) =>
    currencyCode === "GBP"
      ? "£"
      : currencyCode
        ? "€"
        : currencyCode

  return {
    formatToMerchantCurrencyString,
    getCurrencySymbol,
    formatToCurrencyString,
    formatToMerchantGroupCurrencyString,
  }
}
